import { CoreNavigationbar, CoreNavigationbarItem } from '@komodo-design-system/komodo-components-react';
import { searchActions } from 'actions/search';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { simpleSearchPayloadType } from 'type/homeType';
import { findElementByPrompt } from 'utils/utils';
import './HeadingNavBar.scss';
import { useNavigate } from 'react-router';
import {HOME_PAGE } from 'constants/routes';
import ActionPopUp from 'containers/HomePageV2/ActionPopUp';
import Actions from 'componentsV2/Shared/Actions';
import AlertBox from 'componentsV2/SharedAlertBox/AlertBox/AlertBox';

interface HeadingNavBarProps {
  pageTitle: string;
  activeTab: string;
  name?: string;
  assetDetails?: any; // Adjust type as needed
  handleClick?: any;
  from?: string; // Navigation context for dynamic close behavior
}
const HeadingNavBar : React.FC<HeadingNavBarProps>= ({pageTitle, activeTab, name,assetDetails,handleClick, from}) => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const keyword = findElementByPrompt(assetDetails, 'ID')?.value?.id; 
  const assetData = useSelector((state: any) => state.getSimpleSearch.data)?.asset_metadata_search_results?.[0] || {};
  const navigate=useNavigate();
  const [actionPopUp, setActionPopUp] = useState({
    isOpen: false,
    inputProps: {},
    iconRef: "" 
  });
  const [actions, setActions] = useState<{
    operate: boolean;
    action: string;
    inputProps: any;
    handleActionResponse: (response: any) => void;
      }>({
        operate: false,
        action: '',
        inputProps: {},
        handleActionResponse: () => {}
      });
  const [responseAlert, setResponseAlert] = useState({ isOpen: false, message: '' });
  // show tabs based on the page
  const path= window.location.pathname;
  const iconRef = 'heading-nav-bar-popup';
  const [tabs, setTabs] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    if(keyword){
      const payload: simpleSearchPayloadType = {
        keyword: keyword,
        pageNumber: 1,
        pageSize: 1
      };
      dispatch(searchActions.simpleSearch(payload));
    }
  },[assetDetails]);

  const handleHomeClick = () => {
    if (from) {
      // Navigate back to the specified source page
      navigate(`${from}`);
    } else {
      // Default behavior - go to home page
      navigate(HOME_PAGE);
    }
  };

  const handleActionMoreClick = () => {
    setActionPopUp({
      isOpen: true,
      inputProps: assetData || {},
      iconRef: iconRef,
    });
  
  };
  const handleActionResponse = (response: any,action:string,inputProps:any) => {
    setActions({ operate: false, action: '', inputProps: {}, handleActionResponse: () => {} }); // Reset actions state
    if (response?.status?.toString() === '200') {
      setResponseAlert({
        isOpen: true,
        message: response?.message || `Asset ${action} successfully.`,
      });
      // Optionally, refresh the data after successful action
      setTimeout(() => {
        navigate(HOME_PAGE);
      }, 1000); // Delay to allow user to see the alert
    } else {
      setResponseAlert({
        isOpen: true,
        message: `Failed to ${action} asset.`,
      });
    }
  };
  const handleAction = (action: string, inputProps?: any) => {
    setActionPopUp({isOpen: false, inputProps: {},iconRef:''}); // Close the popup after action
    setActions({
      operate: true,
      action,
      inputProps,
      handleActionResponse: (response) => handleActionResponse(response, action, inputProps)
    });
  };

  const handleCloseAlert = () => {
    setResponseAlert({ isOpen: false, message: '' });
  };

  useEffect(() => {
    const getTabs = () => {
      if (path.includes('asset-detail')) {
        tabs.push(
          { label: `Metadata ${name ? `(${name})` : ''}`, value: 'Metadata' },
          { label: `Audit ${name ? `(${name})` : ''}`, value: 'Audit' }
        );
      }
      else if (path.includes('asset-check-in')) {
        tabs.unshift({ label: `CheckOut ${name ? `(${name})` : ''}`, value: 'CheckOut' });
      }
      else {
        tabs.push(
          { label: `Metadata ${name ? `(${name})` : ''}`, value: 'Metadata' },
        );
      }
      setTabs(tabs);
    };
    getTabs();
  }, [path]);

  return (
    <div className='heading-nav-bar'>
      <div className='page-title'>{pageTitle}</div>
      <div className='navigation-bar'>
        <CoreNavigationbar variant="horizontal" style={{ width: '100%' }}>
          {tabs.map((tab) => (
            <CoreNavigationbarItem
              variant='horizontal'
              slot='nav-item'
              key={tab.value}
              label={tab.label}
              selected={activeTab === tab.value}
              onClick={() => handleClick(tab.value)}
            />
          ))}
        </CoreNavigationbar>
        <div className='action-icons-bar'>
          <span className='icon-24-close-bold in-active' onClick={handleHomeClick} title='Close'></span>
          <span className='icon-24-moreHori-bold in-active' id={iconRef} onClick={handleActionMoreClick} title='Actions' ></span>
        </div>
      </div>
      {actionPopUp?.isOpen && <ActionPopUp action={actionPopUp} handleAction={handleAction}  />}
      {actions.operate && <Actions action={actions?.action} inputProps={actions?.inputProps} handleActionResponse={actions?.handleActionResponse} />}
      {responseAlert?.isOpen && <AlertBox isModalOpen message={responseAlert?.message} handleClose={handleCloseAlert} />}

    </div>
  );
};

export default HeadingNavBar;

